import ga from "@starter/Framework/Common/GoogleAnalytics";

const mapWishListOption = (options: Toolkit.GoogleAnalytics.Options | undefined): Toolkit.GoogleAnalytics.Event => {
    if (!options?.wishList) {
        return {};
    }

    const { wishList } = options;

    return {
        item_list_id: wishList.id,
        items: !options?.skipOptionItems ? ga.map.items(wishList.wishListLineCollection) : undefined,
    };
};

export default mapWishListOption;
